import { makeStyles } from '@mui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    paddingBlock: 70,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      paddingBlock: 50,
    },
  },
  title: {
    '& .MuiTypography-root': {
      textAlign: 'center',
      color: theme.palette.custom.main,
      fontWeight: 600,
      paddingBlockEnd: 28,
      [theme.breakpoints.down('sm')]: {
        fontSize: 28,
      },
    },
  },
  sliderWrapper: {
    width: '100%',
    // paddingBlockStart: 16,
    paddingInline: theme.palette.custom.lgPaddingInline,
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    [theme.breakpoints.up('1700')]: {
      paddingInline: theme.palette.custom.xlPaddingInline,
    },
    [theme.breakpoints.down('md')]: {
      paddingInline: theme.palette.custom.smPaddingInline,
    },
    '& .swiper': {
      width: '100%',
    },
  },
  arrowIcons: {
    position: 'absolute',
    display: 'flex',
    justifyContent: 'space-between',
  },
  cardWrapper: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: 8,
    // width: 198,
    cursor: 'pointer',
    [theme.breakpoints.down('lg')]: {
      width: 160,
    },
    [theme.breakpoints.down('500')]: {
      width: 130,
    },
  },
  imgContainer: {
    width: '100%',
    height: 188,
    [theme.breakpoints.down('lg')]: {
      height: 150,
    },
    [theme.breakpoints.down('500')]: {
      height: 120,
    },
    transition: 'all 0.3s ease-in-out 0s',
    '&:hover': {
      transform: 'scale(1.03)',
      overflow: 'hidden',
      transition: 'all 0.3s ease-in-out 0s',
    },
  },
  img: {
    width: '100%',
    height: '100%',
  },
  label: {
    '& .MuiTypography-root': {
      textAlign: 'center',
    },
  },
  tabWrapper: {
    paddingBlock: 8,
    paddingInline: theme.palette.custom.lgPaddingInline,
    [theme.breakpoints.up('1700')]: {
      paddingInline: theme.palette.custom.xlPaddingInline,
    },
    [theme.breakpoints.down('md')]: {
      paddingInline: theme.palette.custom.smPaddingInline,
    },
    '& .MuiTab-root': {
      marginInlineEnd: 20,
      textTransform: 'capitalize',
      fontSize: 17,
      fontWeight: 500,
      transition: 'all ease .3s',
      border: '1px solid #022247',
      borderRadius: 10,
      minHeight: 32,
      padding: '6px 24px',
    },
    '& .MuiTabs-indicator': {
      height: 0,
    },
    '& .Mui-selected': {
      color: '#ffffff !important',
      backgroundColor: theme.palette.custom.main,
    },
  },
  emptyData: {
    '& .MuiTypography-root': {
      paddingBlock: 12,
      textAlign: 'center',
    },
  },
}))

export default useStyles
